const getCookie = (name) => {
    let matches = document.cookie.match(
        new RegExp(
            `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`,
        ),
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
};

const setCookie = (name, value, options = {}) => {
    options = {
        path: "/",
        // при необходимости добавьте другие значения по умолчанию
        ...options,
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(
        value,
    )}`;

    for (let optionKey in options) {
        if (Object.hasOwn(options, optionKey)) {
            updatedCookie += `; ${optionKey}`;
            let optionValue = options[optionKey];

            if (optionValue !== true) {
                updatedCookie += `=${optionValue}`;
            }
        }
    }

    document.cookie = updatedCookie;
};

const deleteCookie = (name, options) => {
    setCookie(name, "", {
        "max-age": -1,
        ...options,
    });
};

export { getCookie, setCookie, deleteCookie };
